const bindAll = require('lodash.bindall');
const React = require('react');
const PropTypes = require('prop-types');
import {FormattedMessage} from 'react-intl';
const {injectIntl, intlShape} = require('react-intl');

import ProjectFlowStep from './project-flow-step.jsx';

require('./project-flow-steps.scss');

class SavingErrorStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSubmit'
        ]);
    }
    componentDidMount () {
        if (this.props.sendAnalytics) {
            this.props.sendAnalytics('join-error');
        }
    }
    handleSubmit (e) {
        // ProjectFlowStep includes a <form> that handles a submit action.
        // But here, we're not really submitting, so we need to prevent
        // the form from navigating away from the current page.
        e.preventDefault();
        this.props.onSubmit();
    }
    render () {
        return (
            <ProjectFlowStep
                innerClassName="join-flow-inner-error-step"
                nextButton={this.props.canTryAgain ?
                    this.props.intl.formatMessage({id: 'general.tryAgain'}) :
                    this.props.intl.formatMessage({id: 'general.startOver'})
                }
                title={this.props.intl.formatMessage({id: 'general.error'})}
                titleClassName="join-flow-error-title"
                onSubmit={this.handleSubmit}
            >
                <div className="join-flow-instructions">
                    <FormattedMessage id="project.cantCreate" />
                </div>
                {this.props.errorMsg && (
                    <div className="join-flow-instructions registration-error-msg">
                        {this.props.errorMsg}
                    </div>
                )}
                {this.props.canTryAgain ? (
                    <div className="join-flow-instructions">
                        <FormattedMessage id="project.tryAgainInstruction" />
                    </div>
                ) : (
                    <div className="join-flow-instructions">
                        <FormattedMessage id="project.startOverInstruction" />
                    </div>
                )}
            </ProjectFlowStep>
        );
    }
}

SavingErrorStep.propTypes = {
    canTryAgain: PropTypes.bool.isRequired,
    errorMsg: PropTypes.string,
    intl: intlShape,
    onSubmit: PropTypes.func.isRequired,
    sendAnalytics: PropTypes.func.isRequired
};

SavingErrorStep.defaultProps = {
    canTryAgain: false
};

const IntlSavingErrorStep = injectIntl(SavingErrorStep);

export default IntlSavingErrorStep;
